import { render, staticRenderFns } from "./OrderDetailsPrintView.vue?vue&type=template&id=79831bf4&scoped=true&"
import script from "./OrderDetailsPrintView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsPrintView.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsPrintView.vue?vue&type=style&index=0&id=79831bf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79831bf4",
  null
  
)

export default component.exports